import { TransportTypes as CommonTransportTypes } from '../common/enums/TransportTypes'

export class TransportTypes extends CommonTransportTypes {}
